import React, { useState } from 'react';
import Loading from 'components/_common/Loading';
import NoData from 'components/_common/NoData';

const StockV = ({ list, isLoaded, error, onRefresh, onSave, onSearch }) => {
    const [editingId, setEditingId] = useState(null);
    const [editForm, setEditForm] = useState({
        inboundCnt: 0,
        outboundCnt: 0,
        stock: 0,
    });
    const [keyword, setKeyword] = useState('');

    // 총 재고 계산
    const totalStock = list.reduce((sum, item) => sum + item.stock, 0);
    const totalInbound = list.reduce((sum, item) => sum + item.inboundCnt, 0);
    const totalOutbound = list.reduce((sum, item) => sum + item.outboundCnt, 0);

    // 수정 모드 시작
    const handleEdit = (item) => {
        setEditingId(item.id);
        setEditForm({
            inboundCnt: item.inboundCnt,
            outboundCnt: item.outboundCnt,
            stock: item.stock,
        });
    };

    // 수정 취소
    const handleCancel = () => {
        setEditingId(null);
        setEditForm({ inboundCnt: 0, outboundCnt: 0, stock: 0 });
    };

    // 저장
    const handleSaveClick = (item) => {
        const updatedItem = {
            ...item,
            inboundCnt: Number(editForm.inboundCnt),
            outboundCnt: Number(editForm.outboundCnt),
            stock: Number(editForm.stock),
        };
        onSave(updatedItem);
        setEditingId(null);
    };

    // 입력 변경
    const handleInputChange = (field, value) => {
        setEditForm((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    // 검색 처리
    const handleSearch = (e) => {
        e.preventDefault();
        onSearch(keyword);
    };

    // 검색 초기화
    const handleReset = () => {
        setKeyword('');
        onSearch('');
    };

    return (
        <>
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>
                                <i className="fas fa-boxes mr-2"></i>
                                <span>보일러 재고</span>
                            </h1>
                        </div>
                        <div className="col-sm-6">
                            <button
                                className="btn btn-primary float-right"
                                onClick={onRefresh}
                                disabled={!isLoaded}
                            >
                                <i className="fas fa-sync-alt mr-1"></i>
                                새로고침
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                {!isLoaded ? (
                    <Loading />
                ) : error ? (
                    <div className="alert alert-danger">
                        <i className="fas fa-exclamation-triangle mr-2"></i>
                        {error}
                    </div>
                ) : (
                    <>
                        {/* 검색 영역 */}
                        <div className="card card-outline card-primary mb-3">
                            <div className="card-header">
                                <h3 className="card-title">
                                    <i className="fas fa-search mr-2"></i>
                                    검색
                                </h3>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSearch}>
                                    <div className="row">
                                        <div className="col-md-10">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="제품코드 또는 제품명으로 검색"
                                                value={keyword}
                                                onChange={(e) => setKeyword(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <div className="btn-group w-100">
                                                <button
                                                    type="submit"
                                                    className="btn btn-success"
                                                    style={{ flex: 1 }}
                                                >
                                                    <i className="fas fa-search mr-1"></i>
                                                    검색
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    onClick={handleReset}
                                                    style={{ flex: 1 }}
                                                >
                                                    <i className="fas fa-redo mr-1"></i>
                                                    초기화
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* 재고 테이블 */}
                        <div className="card card-outline card-primary">
                            <div className="card-header">
                                <h3 className="card-title">
                                    <i className="fas fa-list mr-2"></i>
                                    제품별 재고 현황
                                    {/* {keyword && (
                                        <span className="badge badge-info ml-2">
                                            검색결과: {list.length}건
                                        </span>
                                    )} */}
                                </h3>
                                <div className="card-tools">
                                    <span className="badge badge-info">
                                        <i className="fas fa-info-circle mr-1"></i>
                                        각 행을 클릭하여 입고/출고/재고를 직접 수정할 수 있습니다
                                    </span>
                                </div>
                            </div>
                            <div className="card-body table-responsive p-0">
                                {list.length === 0 ? (
                                    <NoData />
                                ) : (
                                    <table className="table table-hover text-nowrap">
                                        <thead>
                                            <tr className="bg-light">
                                                <th style={{ width: 60 }}>No</th>
                                                <th style={{ minWidth: 150 }}>보일러명</th>
                                                <th className="text-end" style={{ width: 150 }}>입고</th>
                                                <th className="text-end" style={{ width: 150 }}>출고</th>
                                                <th className="text-end" style={{ width: 150 }}>현재고</th>
                                                <th className="text-center" style={{ width: 150 }}>수정</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list.map((row, idx) => (
                                                <tr key={row.id}>
                                                    <td>{idx + 1}</td>
                                                    <td>
                                                        <strong>{row.productName}</strong>
                                                        <br />
                                                        <small className="text-muted">{row.productCode}</small>
                                                    </td>
                                                    <td className="text-end">
                                                        {editingId === row.id ? (
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-sm text-end"
                                                                value={editForm.inboundCnt}
                                                                onChange={(e) => handleInputChange('inboundCnt', e.target.value)}
                                                                min="0"
                                                            />
                                                        ) : (
                                                            <span>
                                                                <strong>{row.inboundCnt.toLocaleString()}</strong>
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="text-end">
                                                        {editingId === row.id ? (
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-sm text-end"
                                                                value={editForm.outboundCnt}
                                                                onChange={(e) => handleInputChange('outboundCnt', e.target.value)}
                                                                min="0"
                                                            />
                                                        ) : (
                                                            <span>
                                                                <strong>{row.outboundCnt.toLocaleString()}</strong>
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="text-end">
                                                        {editingId === row.id ? (
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-sm text-end"
                                                                value={editForm.stock}
                                                                onChange={(e) => handleInputChange('stock', e.target.value)}
                                                            />
                                                        ) : (
                                                            <span>
                                                                <strong>{row.stock.toLocaleString()}</strong>
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        {editingId === row.id ? (
                                                            <div className="btn-group btn-group-sm">
                                                                <button
                                                                    className="btn btn-success"
                                                                    onClick={() => handleSaveClick(row)}
                                                                    title="저장"
                                                                >
                                                                    <i className="fas fa-check"></i>
                                                                </button>
                                                                <button
                                                                    className="btn btn-secondary"
                                                                    onClick={handleCancel}
                                                                    title="취소"
                                                                >
                                                                    <i className="fas fa-times"></i>
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <button
                                                                className="btn btn-sm btn-primary"
                                                                onClick={() => handleEdit(row)}
                                                                title="수정"
                                                            >
                                                                <i className="fas fa-edit"></i>
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default StockV;